import account from "@/api/account";
import Vue from "vue";
import {vuex} from "@/common/util";
import attach from "@/api/attach";
import founder from "@/api/founder";
import shop from "@/api/shop";
import user from "@/api/user";
export default {
    founder,
    account,
    attach,
    shop,
    user,
    globalSet: ()=> {
        Vue.axios.get("/app/global-set").then(res=>{
            vuex("vuex_global_set",res);
        })
    }
}

